import React from 'react';
import PropTypes from 'prop-types';


import * as styleUtils from '../../../utils/styleUtils';

import * as iconConstants from './iconConstants';

import styles from './Icon.scss';


function Icon({icon}) {

    return (
        <i className={styleUtils.toClasses(styles.icon, styles[icon])}/>
    );
}


Icon.propTypes = {
    icon: PropTypes.oneOf(iconConstants.ICONS).isRequired
};


export default Icon;
